
(() => {
  const normalize = (value) =>
    String(value ?? '').trim().toLowerCase();

  const filenameStem = (value) => {
    const filename = String(value ?? '')
      .split('?')[0]
      .split('/')
      .pop();

    try {
      return decodeURIComponent(filename)
        .replace(/\.[^.]+$/, '')
        .replace(/_\d+$/, '')
        .toLowerCase();
    } catch {
      return '';
    }
  };

  function readJSON(id) {
    const element = document.getElementById(id);
    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('Variant gallery JSON error:', error);
      return null;
    }
  }

  function setupGallery(gallery) {
    const sectionId = gallery.id.replace('MediaGallery-', '');

    const mapping = readJSON(`VariantGalleryMapping-${sectionId}`);
    const variants = readJSON(`VariantGalleryVariants-${sectionId}`);

    if (!mapping?.groups?.length || !Array.isArray(variants)) {
      return;
    }

    const productSection = gallery.closest('section') ||
      gallery.parentElement;

    const variantInput = document.querySelector(
      `input[name="id"][form="product-form-${sectionId}"]`
    ) || document.querySelector(
      `#product-form-${sectionId} input[name="id"]`
    );

    if (!variantInput) return;

    const slides = Array.from(
      gallery.querySelectorAll(
        '.product__media-item[data-image-filename]'
      )
    );

    const thumbnails = Array.from(
      gallery.querySelectorAll(
        '.thumbnail-list__item[data-target]'
      )
    );

    // Keep the original display state for restoration.
    const originalDisplay = new Map();

    [...slides, ...thumbnails].forEach(element => {
      originalDisplay.set(element, element.style.display);
    });

    function update() {
      const variant = variants.find(
        item => String(item.id) === String(variantInput.value)
      );

      if (!variant) return;

      const selectedOptions = [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(value => value != null).map(normalize);

      const group = mapping.groups.find(item =>
        Array.isArray(item.options) &&
        item.options.length === selectedOptions.length &&
        item.options.every(
          (option, index) =>
            normalize(option) === selectedOptions[index]
        )
      );

      if (!group || !Array.isArray(group.images)) {
        return;
      }

      const prefixes = group.images.map(normalize);

      const matchingSlides = slides.filter(slide => {
        const stem = filenameStem(slide.dataset.imageFilename);
        return prefixes.includes(stem);
      });

      // Never empty the gallery if mapping is incorrect.
      if (!matchingSlides.length) return;

      const visibleIds = new Set(
        matchingSlides.map(slide => slide.dataset.mediaId)
      );

      slides.forEach(slide => {
        slide.style.display = visibleIds.has(slide.dataset.mediaId)
          ? originalDisplay.get(slide)
          : 'none';
      });

      thumbnails.forEach(thumbnail => {
        thumbnail.style.display = visibleIds.has(
          thumbnail.dataset.target
        )
          ? originalDisplay.get(thumbnail)
          : 'none';
      });

      const activeSlide = matchingSlides.find(
        slide => slide.classList.contains('is-active')
      );

      if (!activeSlide && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(
          matchingSlides[0].dataset.mediaId,
          false
        );
      }

      const viewer = gallery.querySelector(
        '[id^="GalleryViewer"]'
      );

      if (viewer?.resetPages) viewer.resetPages();
    }

    // Respond to changes in variant selectors.
    document.addEventListener('change', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(update);
      });
    });

    update();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
